import { render } from "./PostCardHeader.vue?vue&type=template&id=1d1a60a0&scoped=true"
import script from "./PostCardHeader.vue?vue&type=script&lang=js"
export * from "./PostCardHeader.vue?vue&type=script&lang=js"

import "./PostCardHeader.vue?vue&type=style&index=0&id=1d1a60a0&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d1a60a0"]])

export default __exports__